<template>
  <div id="set">

    <md-card>

      <!-- Thumbnail -->
      <md-card-media
        v-if="(set.figures && set.figures[0].youtube) || set.thumbnail"
        key="setThumbnail">
        <img
          :src="set.figures[0].youtube ? getThumbnail(set.figures[0].youtube.url) : getThumbnail(set.thumbnail)"
          alt="" />
      </md-card-media>

      <!-- Title -->
      <md-card-header v-if="set.needsSet">
        <div class="md-title">{{ setName }} Set</div>
        <div class="md-subhead">{{ set.jpCaption }}・セット</div>
      </md-card-header>
      <md-card-header v-else>
        <div class="md-title">{{ setName }}</div>
        <div class="md-subhead">{{ set.jpCaption }}</div>
      </md-card-header>

      <!-- カウンティ -->
      <div
        class="county"
        v-if="set.county"
        key="setCounty">
        <img
          v-for="county in set.county"
          :src="getAvatar(county)"
          width="40" />
        <br />
        County {{ getCounty(set.county) }}
      </div>

      <p v-if="set.editer">Created By {{ set.editer }}</p>

      <!-- 特徴 -->
      <p
        class="notices"
        v-if="set.notices"
        key="setNotices">
        {{ set.notices }}<br />
      </p>

      <md-subheader>すべてのフィガー</md-subheader>
      <md-list id="setInfo">
        <md-list-item
          v-for="(figure,index) in set.figures"
          :key="index"
          class="md-double-line">
          <div class="md-list-text-container">
            <span>
              <a
                :href="'/#/set/' + setName + '/#'"
                v-scroll-to="'#figure' + index">
                Figure {{ figure.order }}: {{ figure.summary }}
              </a>
            </span>
            <p v-if="(set.hasLeadIn === undefined) || (figure.order === 1)"
              class="bars-info"
              @click="getBarsInfo('barsdialog', figure)">
              {{ getBars(figure) }} bars + 8 bars lead in
            </p>
            <p v-else>
              {{ getBars(figure) }} bars
            </p>
          </div>
          <md-chip class="md-primary">
            {{figure.rythmn}}
          </md-chip>
          <md-divider></md-divider>
        </md-list-item>
        <router-link
          tag="md-button"
          :to="{ name: 'Figures', params: { setName: setName }}"
          v-if="!isOriginalSet"
          id="showFigures"
          class="md-raised md-primary">
          すべてのフィガーをみる
        </router-link>

      </md-list>

      <md-card-content id="figure">
        <md-card
          v-for="(figure, figureIndex) in set.figures"
          :key="figure.order"
          :id="'figure' + figureIndex">
          <md-card-header>
            <div class="md-title">Figure {{figure.order}}: {{figure.summary}} <md-chip class="md-primary">{{figure.rythmn}}</md-chip></div>
            <div class="md-subhead bars-info" @click="getBarsInfo('barsdialog', figure)">{{ getBars(figure) }} bars + 8 bar lead in</div>
          </md-card-header>

          <md-card-content
            v-if="figure.description || figure.youtube"
            key="figureMovieContainer">
            <!-- <iframe v-if="figure.youtube" width="560" height="315" :src="figure.youtube.url + '?rel=0&amp;start=' + figure.youtube.start" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe> -->
            <youtube
              v-if="figure.youtube"
              :video-id="getYouTubeId(figure.youtube.url)"
              player-height="auto"
              player-width="auto"
              :player-vars="{ start: figure.youtube.start }"
              class="youtube"
              key="figureMovie"></youtube>

            {{ figure.description }}
          </md-card-content>

          <md-list>
            <md-list-item
              v-for="(movement, index) in figure.movements"
              v-if="movement.bar !== ''"
              :key="index"
              :class="movement.type"
              class="movement"
              @click="openMovementCaption('captiondialog', figureIndex, movement.summary, movement.caption, movement.image)">
              <span
                v-if="movement.type === 'call-repeat'"
                :class="movement.type"
                class="bar"
                key="callRepeatPart">
                <md-chip class="md-primary">{{ movement.bar }}</md-chip>
              </span>
              <span
                v-else-if="movement.type === 'repeat'"
                :class="movement.type"
                class="bar"
                key="repeatPart">
                <md-chip class="md-primary">{{ movement.bar }}</md-chip>
              </span>
              <span
                v-else-if="movement.type === 'nested-repeat'"
                :class="movement.type"
                class="bar"
                key="nestedRepeatPart">
                <md-chip class="md-accent">{{ movement.bar }}</md-chip>
              </span>
              <span
                v-else-if="movement.type === 'call-nested-repeat'"
                :class="movement.type"
                class="bar"
                key="callNestedRepeatPart">
                <md-chip class="md-accent">{{ movement.bar }}</md-chip>
              </span>
              <span v-else
                :class="movement.type"
                class="bar"
                key="noramlPart">
                <md-chip class="md-default">{{ movement.bar }}</md-chip>
              </span>
              <div class="md-list-text-container">
                <span
                  v-if="!movement.caption"
                  class="summary"
                  key="movementWithoutCaption">
                  {{ movement.summary }}
                </span>
                <span v-else key="movementWithCaption">
                  <md-button
                    @click="openMovementCaption('captiondialog', figureIndex, movement.summary, movement.caption, movement.image)"
                    class="summary">
                    {{ movement.summary }}<i class="material-icons">launch</i><div class="clear"></div>
                  </md-button>
                </span>
                <span
                  v-if="movement.subject"
                  key="movementWithSubject">
                  {{movement.subject}}
                </span>
              </div>
              <md-divider v-if="index !== figure.movements.length - 1"></md-divider>
            </md-list-item>
          </md-list>
        </md-card>
      </md-card-content>

      <md-divider></md-divider>

      <md-card-content>

        <md-button
          v-if="set.referenceSite && set.referenceSite.danceminder"
          :href="set.referenceSite.danceminder"
          class="md-raised md-primary launchButton"
          key="danceminder"
          target="_blank">DanceMinder <i class="material-icons">launch</i></md-button>
        <md-button
          v-if="set.referenceSite && set.referenceSite.irishSetDancing"
          :href="set.referenceSite.irishSetDancing"
          class="md-raised md-primary launchButton"
          key="setdancingnews"
          target="_blank">Set Dancing News <i class="material-icons">launch</i></md-button>

        <md-button
          v-if="set.referenceSite && set.referenceSite.crookedriver"
          :href="set.referenceSite.crookedriver"
          class="md-raised md-primary launchButton"
          key="crookedriver"
          target="_blank">Crooked River <i class="material-icons">launch</i></md-button>

        <p class="discharge">
          SetDancePal に記載されている内容は "Toss The Feathers", DanceMinder, Set Dancing News、CCÉ Japan、
          YouTube、日本のケーリーなどで城が踊った経験をもとに書かれています。<br />
          誤字脱字、誤りなどありましたらお手数ですが以下のボタンからご報告ください。
        </p>

        <router-link
          tag="md-button"
          :to="{ name: 'EditSet', params: { setName: setName }}"
          v-if="isOriginalSet"
          class="md-raised md-primary">
          セットを編集する
        </router-link>

        <router-link
          tag="md-button"
          :to="{ name: 'Report', params: { setName: setName }}"
          v-if="!isOriginalSet"
          class="md-raised">
          誤字脱字を報告する
        </router-link>

      </md-card-content>

    </md-card>

    <md-speed-dial
      md-mode="scale"
      id="view-setting"
      class="md-fab-bottom-right">
　      <md-button
          :href="'/#/set/' + setName + '/#'"
          v-scroll-to="'#set'"
          class="md-fab"
          md-fab-trigger>
        <md-icon>arrow_upward</md-icon>
      </md-button>
    </md-speed-dial>

    <md-dialog
      md-open-from="#custom"
      md-close-to="#custom"
      @open="onOpen"
      @close="onClose"
      ref="barsdialog">
      <md-dialog-title>
        {{ barsInfo.title }}
      </md-dialog-title>

      <md-dialog-content>
        <ul>
          <li>{{ barsInfo.rythmn }}</li>
          <li>{{ barsInfo.bars }}</li>
        </ul>
        　{{ barsInfo.contentHtml }}
        <!-- <ul>
          <li v-if="!Array.isArray(barsInfo.contentHtml)" key="one_sentence">{{ barsInfo.contentHtml }}</li>
          <li v-else v-for="instruction, index in barsInfo.contentHtml" :key="index">{{ instruction }}</li>
        </ul> -->
      </md-dialog-content>

      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="closeDialog('barsdialog')">{{ barsInfo.close }}</md-button>
      </md-dialog-actions>

    </md-dialog>

    <md-dialog
      md-open-from="#custom"
      md-close-to="#custom"
      @open="onOpen"
      @close="onClose"
      ref="captiondialog">
      <md-dialog-title>
        <img
          :src="'/static/img/movement/' + alert.image"
          v-if="alert.image"
          key="animation"
          class="animation" />
        {{ alert.title }}
      </md-dialog-title>

      <md-dialog-content>
        <!-- {{ alert.contentHtml }} -->
        <ul>
          <li v-if="!Array.isArray(alert.contentHtml)" key="one_sentence">{{ alert.contentHtml }}</li>
          <li v-else v-for="instruction, index in alert.contentHtml" :key="index">{{ instruction }}</li>
        </ul>
      </md-dialog-content>

      <md-dialog-actions>
        <router-link
          class=""
          tag="md-button"
          :to="{ name: 'ReportMovement', params: { setName: setName, figureNumber: alert.figureNumber, movement: alert.title }}">
          誤字脱字を報告する
        </router-link>
        <md-button
          class="md-primary"
          @click="closeDialog('captiondialog')">{{ alert.close }}</md-button>
      </md-dialog-actions>

    </md-dialog>

  </div>
</template>

<script>
import db from '../db'
import { getIdFromURL } from 'vue-youtube-embed'

export default {
  name: 'set',
  data () {
    return {
      error: null,
      setName: this.$route.params.setName,
      set: {},
      county: '',
      isOriginalSet: false,
      alert: {
        title: 'hoge',
        contentHtml: ' ',
        figureNumber: 0,
        close: '閉じる' // / Close
      },
      barsInfo: {
        title: 'hoge',
        contentHtml: ' ',
        rythmn: 'hoge',
        bars: 'hoge',
        close: '閉じる' // / Close
      }
    }
  },
  firebase: {
    // set: db.ref('/sets/' + this.setName)
  },
  computed: {
    numberOfFigures: function () {
      return 'numberOfFiguresIs' + this.set.figures.length.toString()
    }
  },
  created () {
    let self = this
    db.ref('/sets/' + this.setName).once('value').then(function (set) {
      if (set.val()) {
        self.set = set.val()
        console.log(set.hasLeadIn)
      } else {
        db.ref('/originalSets/' + self.setName).once('value').then(function (originalSet) {
          // console.log('Listen', originalSet.val())
          self.set = originalSet.val()
          self.isOriginalSet = true
        })
      }
    })
  },
  watch: {
    '$route': 'refreashData'
  },
  beforeRouteEnter: (to, from, next) => {
    db.ref('/sets/' + to.params.setName).once('value').then(function (set) {
      next((vm) => {
        vm.set = set.val()
      })
    })
  },
  methods: {
    refreashData () {
      this.setName = this.$route.params.setName
      let self = this
      db.ref('/sets/' + this.$route.params.setName).once('value').then(function (set) {
        self.set = set.val()
      })
    },
    getAvatar: function (county) {
      return '/static/img/county/' + county + '_Crest.png'
    },
    getCounty: function (counties) {
      // iPod Touch などの旧デバイスで配列が2重で表示されないようにする
      counties = counties.filter(function (x, i, self) { return self.indexOf(x) === i })

      let str = ''
      for (let c in counties) {
        str += counties[c] + ', '
      }
      str = str.substring(0, str.length - 2)
      return str
    },
    getSlideId: function (id) {
      return 'slide' + id
    },
    getBars: function (figure) {
      let bars = 0
      for (let i in figure.movements) {
        if (figure.movements[i].bar !== '') {
          bars += figure.movements[i].bar
        }
      }

      return bars
    },
    getBarsInfo (ref, figure) {
      if (!figure) { return }

      let bars = 0
      for (let i in figure.movements) {
        if (figure.movements[i].bar !== '') {
          bars += figure.movements[i].bar
        }
      }

      let mod = (bars + 8) % 16

      this.barsInfo.title = 'Figure ' + figure.order + ': ' + figure.summary
      this.barsInfo.rythmn = figure.rythmn
      this.barsInfo.bars = bars + ' bars + 8 bars lead in'
      this.barsInfo.contentHtml = mod ? ' = 16 bars × ' + Math.floor((bars + 8) / 16) + ' + ' + mod + ' bars' : ' = 16 bars × ' + Math.floor((bars + 8) / 16)
      this.$refs[ref].open()
    },
    existsYouTubes: function (youtubes) {
      return youtubes !== undefined && youtubes.length > 0 && youtubes[0].url.length > 0
    },
    getYouTubeId: function (url) {
      return getIdFromURL(url + '?o=U&noapp=1')
    },
    getThumbnail: function (url) {
      return 'https://i.ytimg.com/vi/' + getIdFromURL(url) + '/maxresdefault.jpg'
      // return 'http://i.ytimg.com/vi/' + getIdFromURL(url) + '/sddefault.jpg'
    },
    openMovementCaption (ref, figureNumber, title, contentHtml, image) {
      if (!contentHtml) { return }
      this.alert.title = title
      this.alert.contentHtml = contentHtml
      this.alert.figureNumber = figureNumber
      this.alert.image = image
      this.$refs[ref].open()
    },
    closeDialog (ref) {
      this.$refs[ref].close()
    },
    onOpen () {
    },
    onClose (type) {
      // console.log('Closed', type)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.county {
  margin-bottom: 12px;
}

.county img {
  margin-bottom: 4px;
  margin-left: 8px;
  margin-right: 8px;
}

h1 {
  font-weight: normal;
}

h1 span {
    display: block;
    margin-top: 16px;
    font-size: 16px;
}

.bars-info {
  cursor: pointer;
}

.md-dialog-content ul {
  margin: 0;
  margin-left: 16px;
}

#view-setting.md-speed-dial [md-fab-trigger] {
  position: fixed;
  right: 8px;
  bottom: 8px;
}

.md-speed-dial.md-direction-top [md-fab-trigger] ~ .md-button {
  right: 16px;
  position: fixed;
}

.md-speed-dial.md-direction-top [md-fab-trigger] ~ .md-button:nth-child(2) {
  bottom: 70px;
}

.md-speed-dial.md-direction-top [md-fab-trigger] ~ .md-button:nth-child(3) {
  bottom: 122px;
}

.md-speed-dial.md-direction-top [md-fab-trigger] ~ .md-button:nth-child(4) {
  bottom: 172px;
}

#view-setting .md-theme-default.md-button:not([disabled]).md-fab {
    /*background-color: #ffcd87;*/
}

#showFigures {
  margin-top: 24px;
  margin-bottom: 16px;
}

#tabs {
  margin-top: 20px;
}

#setInfo {
  overflow-x: auto;
}

#setInfo li {
  padding: 4px 0;
}

#setInfo span {
  line-height: 1.6em;
}

#setInfo p {
  margin-bottom: 4px;
  line-height: 1.6em;
}

.md-boards .md-board {
  padding: 16px 0;
}

/*#figure */
#figure {
  padding-bottom: 48px;
}

#figure .md-title .md-chip {
  vertical-align: middle;
}

#figure .md-card {
  margin-bottom: 16px;
}

#figure .md-list-text-container .md-button {
  background-color: inherit;
  line-height: inherit;
  margin: 0;
  min-height: inherit;
  min-width: inherit;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: bold;
  text-align: left;
  text-transform: none;
  width: 100%;
}

#figure .md-list-text-container .md-button i {
  /*float: right;*/
  position: absolute;
  right: 0;
  /*padding-left: 4px;*/
  /*font-size: 18px;*/
  font-size: 20px;
  font-weight: normal;
  vertical-align: middle;
}

#figure .md-list-text-container > * {
  overflow: visible;
}

.movement.common {
  background-color: #efefef;
}

.movement.repeat,
.movement.nested-repeat,
.movement.call-nested-repeat {
  background-color: #ffcd87;
}

.movement.nested-repeat .summary,
.movement.nested-repeat .md-button.summary {
  color: #f44336;
}

span.bar {
  width: 52px;
  margin-left: -16px;
  text-align: center;
}

span.bar.call-nested-repeat .md-theme-default.md-chip.md-accent {
  font-weight: bold;
}

span.bar.call-nested-repeat-connemara .md-theme-default.md-chip.md-accent {
  font-weight: bold;
}

span.type.common,
span.type.repeat,
span.type.call-repeat,
span.type.nested-repeat,
span.type.call-nested-repeat  {
  margin-right: -4px;
}

span.type.nested-repeat {
  font-weight: bold;
}

span.type.nested-repeat .md-theme-default.md-chip.md-primary {
  color: #f44336;
}

ul {
  padding: 2px 0;
}

p.notices {
  margin-top: 12px;
  margin-bottom: 16px;
  font-style: italic;
}

#figDispConfig {
  margin-top: 16px;
}

h3 {
  margin: 12px;
}

p {
  margin: 8px;
}

a {
  color: #42b983;
}

.animation {
  margin-bottom: 16px;
}

.clear {
  clear: both;
}

.youtube {
  margin-bottom: 24px;
}

html, body, section {
  height: 100%;
}

.figure {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

section {
  margin-bottom: 24px;
}

table {
  float: left;
}

table.figure {
  float: none;
}

/*http://www.color-hex.com/color-palette/39118*/

.launchButton {
  /*padding: 8px 16px 12px 16px;*/
  /*margin: 32px 0;*/
  /*margin-bottom: 16px;*/
  /* padding-bottom: 24px; */
  color: #666;
  font-weight: normal;
  text-transform: none;
}

.launchButton i {
  margin-bottom: 2px;
  font-size: 16px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// Set.vue?76142832